<template>
	<footer>
		<div class="footer-body">
			<div class="footer-logo-container">
				<div class="mb-sm-8 mb-4">
					<img :src="BpLogo" :alt="`${getGenericContent('footer-logo-alt-generic')}`" />
				</div>
				<div>
					{{ getGenericContent('footer-license-text-generic') }}
					<p class="text-white"></p>
				</div>
			</div>

			<div class="store-logos">
				<h4 class="mb-sm-8 mb-4">{{ getGenericContent('footer-app-store-title') }}</h4>
				<div class="store-logos-container">
					<a
						:href="`${getGenericContent('footer-app-store-link-apple')}`"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							class="mr-4"
							:src="AppleAppBadge"
							:alt="`${getGenericContent('footer-app-store-alt-apple')}`"
						/>
					</a>
					<a
						:href="`${getGenericContent('footer-app-store-link-google')}`"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							class="mr-4"
							:src="GooglePlayBadge"
							:alt="`${getGenericContent('footer-app-store-alt-google')}`"
						/>
					</a>
				</div>
			</div>
		</div>

		<div class="footer-copyright">
			<p>{{ getGenericContent('footer-copy-label') }} {{ copyYear }}</p>
			<ul class="d-flex g-4">
				<li>
					<router-link rel="noopener noreferrer" target="_blank" :to="{ name: 'ContactUnauth' }"
						>Contact us</router-link
					>
				</li>
				<li>
					<router-link rel="noopener noreferrer" target="_blank" :to="{ name: 'HelpAccount' }"
						>Account help</router-link
					>
				</li>
			</ul>
		</div>
	</footer>
</template>

<script lang="ts" setup>
// ====---------------====
// 🚀 Imports
// ====---------------====
import { computed } from 'vue'
import BpLogo from '@/assets/logo.svg'
import AppleAppBadge from '@/assets/app-store-logo.svg'
import GooglePlayBadge from '@/assets/google-play-logo.svg'
import { getGenericContent } from '@/services/cms/utils'

// ====---------------====
// 💡 Data
// ====---------------====
const copyYear = computed<string>(() => {
	const now = new Date()
	return now.getFullYear().toString()
})
</script>

<style lang="scss" scoped>
.text-white {
	color: #fff;
}

footer {
	background-color: $primary-800;
	color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.footer-body {
	display: flex;
	align-items: center;
	gap: 1.5rem;
	justify-content: space-between;
	max-width: 1440px;
	padding-top: 76px;
	padding-bottom: 46px;
	width: 100%;
	padding-inline: var(--page-padding-inline, 32px);
}

.footer-copyright {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	align-items: center;
	gap: 1rem;

	width: 100%;
	max-width: 1440px;
	padding-block: 0;
	padding-inline: var(--page-padding-inline, 32px);
	margin-bottom: 36px;
	padding-top: 2rem;

	position: relative;

	* {
		color: $primary-300;
	}

	a,
	a:visited {
		color: $primary-300;

		&:hover,
		&:focus,
		:active {
			color: $neutral-50;
		}
	}

	.mdi-open-in-new {
		font-size: 1.25rem;
		padding-inline-start: 0.35rem;
	}

	@media only screen and (min-width: 768px) {
		flex-direction: row;
	}
}

.footer-copyright:before {
	content: '';
	height: 1px;
	width: 100%;

	// display: block;

	position: absolute;
	top: -1rem;
	right: 0;
	background-color: #005987;

	margin-bottom: 36px;
}

.footer-logo-container {
	max-width: 600px;

	img {
		max-width: 21rem;
	}
}

.store-logos {
	height: 100%;

	a {
		&:hover,
		&:focus {
			opacity: 0.8;
		}
	}
}

@media only screen and (max-width: 774px) {
	.store-logos-container {
		display: flex;
		flex-direction: column;
		align-items: end;
	}

	.store-logos-container img {
		margin-right: 0 !important;
		margin-bottom: 12px;
	}
}

@media screen and (max-width: $small-glass) {
	.footer-body {
		flex-direction: column;
		padding-block: 48px 16px;
		margin: 0;
	}

	.footer-logo-container {
		max-width: 100%;
		margin-bottom: 24px;

		img {
			max-width: 100%;
		}
	}

	.store-logos {
		width: 100%;
	}

	.store-logos-container {
		display: block;
	}

	.store-logos-container img {
		margin-right: 16px !important;
		margin-bottom: 0;
	}

	.footer-copyright {
		padding-block: 0;
	}
}
</style>
